import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Home, BookOpen, FileText, Calendar, CalendarCheck, Sparkles, GraduationCap, TrendingUp, User, LogOut, Flame } from 'lucide-react';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const navigation = [
    { name: 'Dashboard', path: '/', icon: Home },
    { name: 'Fächer', path: '/subjects', icon: BookOpen },
    { name: 'Hausaufgaben', path: '/homework', icon: FileText },
    { name: 'Klausuren', path: '/exams', icon: CalendarCheck },
    { name: 'Wochenplan', path: '/schedule', icon: Calendar },
    { name: 'Lernhilfen', path: '/lernhilfen', icon: Sparkles },
    { name: 'MSA-Vorbereitung', path: '/msa', icon: GraduationCap },
    { name: 'Fortschritt', path: '/progress', icon: TrendingUp },
    { name: 'Profil', path: '/profile', icon: User },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-slate-100 flex flex-col">
        <div className="p-6 border-b border-slate-100">
          <h1 className="text-2xl font-heading font-bold text-blue-600 tracking-tight">Lernenachplan</h1>
          <p className="text-sm text-slate-500 mt-1">Dein Lernbegleiter</p>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {navigation.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.name.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-primary-50 text-primary-600 shadow-sm'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                }`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* User Section */}
        <div className="p-4 border-t border-slate-100">
          <div className="flex items-center gap-3 mb-4 p-3 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl">
            <div className="flex items-center gap-2">
              <Flame className="text-orange-500" size={24} />
              <div>
                <p className="text-xs text-slate-600 font-medium">Streak</p>
                <p className="text-lg font-heading font-bold text-slate-900">{user?.streak || 0} Tage</p>
              </div>
            </div>
            <div className="ml-auto">
              <p className="text-xs text-slate-600 font-medium">Level</p>
              <p className="text-lg font-heading font-bold text-primary-600">{user?.level || 1}</p>
            </div>
          </div>
          
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="flex items-center gap-3 w-full px-4 py-3 rounded-2xl text-slate-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200 font-medium"
          >
            <LogOut size={20} />
            <span>Abmelden</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
